import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableRow, Paper, Dialog, DialogContent, DialogActions } from '@material-ui/core';
import AppBarModal from './AppBarModal';
import { BtnForm } from './BotonesAccion';
import TareasTerminadas from './TareasTerminadas';
import emma_w from '../../global/imagenes/emma_w.png';

/** Clase CSS (App.css): tablas etiqueta|valor sin borde exterior ni vertical. */
export const CLASE_TABLA_DETALLE = 'detalle-tabla-solo-filas modal-detalle-general-tabla';

/** Paper envolvente opcional (modales genéricos). */
export const CLASE_PAPER_DETALLE = 'detalle-tabla-solo-filas modal-detalle-general-paper';

/** Estilos JSS para este modal y otras tablas de detalle (refuerzo sobre el tema MUI). */
export const useDetalleTablaStyles = makeStyles(() => ({
  paper: {
    boxShadow: 'none !important',
    backgroundColor: 'transparent',
    border: 'none',
  },
  table: {
    borderCollapse: 'collapse',
    width: '100%',
    border: 'none !important',
    outline: 'none',
    '& .MuiTableCell-root': {
      borderLeft: 'none !important',
      borderRight: 'none !important',
      borderTop: 'none !important',
    },
    '& .MuiTableRow-root:not(:last-child) .MuiTableCell-root': {
      borderBottom: '1px solid rgba(0, 0, 0, 0.08) !important',
    },
    '& .MuiTableRow-root:last-child .MuiTableCell-root': {
      borderBottom: 'none !important',
    },
  },
  cellLabel: {
    fontWeight: 600,
    width: '38%',
    verticalAlign: 'top',
    padding: '12px 16px',
  },
  cellValue: {
    verticalAlign: 'top',
    padding: '12px 16px',
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    wordBreak: 'break-word',
  },
}));

export default function Detalle({ titulo, open, config, cerrar, cargando = false }) {
  const classes = useDetalleTablaStyles();

  return (
    <Dialog open={open} onClose={cerrar} fullWidth={true} maxWidth="sm" aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <AppBarModal titulo={titulo} mostrarModal={cerrar} titulo_accion="" accion={() => { }} />
      <DialogContent style={{ padding: 0 }} className="scroll modal-detalle-general-content">
        {
          cargando ? (
            <TareasTerminadas mensaje="Cargando.." marginTop="7%" imagen={emma_w} widthImg="7%" />
          ) : (
            <Paper square elevation={0} className={`${classes.paper} ${CLASE_PAPER_DETALLE}`}>
              <Table className={`${classes.table} ${CLASE_TABLA_DETALLE}`} aria-label={titulo}>
                <TableBody>
                  {config.map((campo) => (
                    <TableRow key={campo.label}>
                      <TableCell component="th" scope="row" className={classes.cellLabel}>
                        {campo.label}
                      </TableCell>
                      <TableCell align="left" className={classes.cellValue}>
                        {campo.value}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>
          )
        }
      </DialogContent>
      <DialogActions>
        <BtnForm texto="CERRAR" callback={cerrar} />
      </DialogActions>
    </Dialog>
  );
}

Detalle.propTypes = {
  config: PropTypes.array.isRequired
}
